import { Answer } from "./answer";
//import { Answer } from "./save-survey-entry.model";

export class SaveSurveyCommand implements ISaveSurveyCommand {
  surveyAppId!: number;
  employeeId!: string | undefined;
  corpId!: string | undefined;
  authenticated!: boolean;
  enteredBy!: string | undefined;
  mobilePhoneNumber!: string | undefined;
  birthDateMonth!: number;
  birthDateDay!: number;
  personalEmail!: string | undefined;
  workEmail!: string | undefined;
  firstName!: string | undefined;
  lastName!: string | undefined;
  items!: Answer[] | undefined;
  surveyEntryId!: number;
  locationOrEventId!: string | undefined;
  surveyCode!: string | undefined;

  constructor(data?: ISaveSurveyCommand) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.surveyAppId = _data["surveyAppId"];
          this.employeeId = _data["employeeId"];
          this.corpId = _data["corpId"];
          this.authenticated = _data["authenticated"];
          this.enteredBy = _data["enteredBy"];
          this.mobilePhoneNumber = _data["mobilePhoneNumber"];
          this.birthDateMonth = _data["birthDateMonth"];
          this.birthDateDay = _data["birthDateDay"];
          this.personalEmail = _data["personalEmail"];
          this.workEmail = _data["workEmail"];
          this.firstName = _data["firstName"];
          this.lastName = _data["lastName"];
          if (Array.isArray(_data["items"])) {
              this.items = [] as any;
              for (let item of _data["items"])
                  this.items!.push(Answer.fromJS(item));
          }
          this.surveyEntryId = _data["surveyEntryId"];
          this.locationOrEventId = _data["locationOrEventId"];
          this.surveyCode = _data["surveyCode"];
      }
  }

  static fromJS(data: any): SaveSurveyCommand {
      data = typeof data === 'object' ? data : {};
      let result = new SaveSurveyCommand();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["surveyAppId"] = this.surveyAppId;
      data["employeeId"] = this.employeeId;
      data["corpId"] = this.corpId;
      data["authenticated"] = this.authenticated;
      data["enteredBy"] = this.enteredBy;
      data["mobilePhoneNumber"] = this.mobilePhoneNumber;
      data["birthDateMonth"] = this.birthDateMonth;
      data["birthDateDay"] = this.birthDateDay;
      data["personalEmail"] = this.personalEmail;
      data["workEmail"] = this.workEmail;
      data["firstName"] = this.firstName;
      data["lastName"] = this.lastName;
      if (Array.isArray(this.items)) {
          data["items"] = [];
          for (let item of this.items)
              data["items"].push(item.toJSON());
      }
      data["surveyEntryId"] = this.surveyEntryId;
      data["locationOrEventId"] = this.locationOrEventId;
      data["surveyCode"] = this.surveyCode;
      return data;
  }
}

export interface ISaveSurveyCommand {
  surveyAppId: number;
  employeeId: string | undefined;
  corpId: string | undefined;
  authenticated: boolean;
  enteredBy: string | undefined;
  mobilePhoneNumber: string | undefined;
  birthDateMonth: number;
  birthDateDay: number;
  personalEmail: string | undefined;
  workEmail: string | undefined;
  firstName: string | undefined;
  lastName: string | undefined;
  items: Answer[] | undefined;
  surveyEntryId: number;
  locationOrEventId: string | undefined;
  surveyCode: string | undefined;
}
